"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutoplay = void 0;
var _react = require("react");
const useAutoplay = ({
  autoplay
}, setIsTouchActive) => {
  const sliderRef = (0, _react.useRef)();
  const timeout = (0, _react.useRef)();
  const [mouseOver, setMouseOver] = (0, _react.useState)(false);
  const clearNextTimeout = (0, _react.useCallback)(() => clearTimeout(timeout.current), []);
  const nextTimeout = (0, _react.useCallback)(() => {
    clearNextTimeout();
    if (!mouseOver && sliderRef.current?.track.details != null) {
      timeout.current = setTimeout(() => sliderRef.current?.next(), autoplay?.interval);
    }
  }, [autoplay?.interval, clearNextTimeout, mouseOver]);
  const onMouseOver = (0, _react.useCallback)(() => {
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout]);
  const onMouseOut = (0, _react.useCallback)(() => {
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout]);
  const onTouchStart = (0, _react.useCallback)(() => {
    setIsTouchActive(true);
    setMouseOver(true);
    clearNextTimeout();
  }, [clearNextTimeout, setIsTouchActive]);
  const onTouchEnd = (0, _react.useCallback)(() => {
    setIsTouchActive(false);
    setMouseOver(false);
    nextTimeout();
  }, [nextTimeout, setIsTouchActive]);
  const plugin = (0, _react.useCallback)(slider => {
    sliderRef.current = slider;
    sliderRef.current.on('created', instance => {
      const parent = instance.container.parentElement;
      parent?.addEventListener('mouseover', onMouseOver);
      parent?.addEventListener('touchstart', onTouchStart);
      parent?.addEventListener('mouseout', onMouseOut);
      parent?.addEventListener('touchend', onTouchEnd);
      nextTimeout();
    });
    sliderRef.current.on('animationEnded', nextTimeout);
    sliderRef.current.on('destroyed', instance => {
      const parent = instance.container.parentElement;
      parent?.removeEventListener('mouseover', onMouseOver);
      parent?.removeEventListener('touchstart', onTouchStart);
      parent?.removeEventListener('mouseout', onMouseOut);
      parent?.removeEventListener('touchend', onTouchEnd);
      sliderRef.current = undefined;
    });
  }, [nextTimeout, onMouseOut, onMouseOver, onTouchEnd, onTouchStart]);
  return autoplay?.enabled ? plugin : undefined;
};
exports.useAutoplay = useAutoplay;
//# sourceMappingURL=useAutoplay.js.map